<template>
  <div class="medical-records-tab medical-records-tab--reports">
    <p class="text-muted mb-0">{{ $t("prontuariosPage.tabs.reports.placeholder") }}</p>
  </div>
</template>

<script>
export default {
  name: "MedicalRecordsReportsTab",
  props: {
    entityType: {
      type: String,
      default: "",
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    patient: {
      type: Object,
      default: null,
    },
  },
};
</script>
